module.exports = __webpack_public_path__ + "static/img/logo.8a7c1ef9.png";